export default __webpack_public_path__ + "static/media/logo.a826f6a1.webp";